import {Injectable, Injector} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {finalize, tap} from "rxjs/operators";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {LoadingService} from "../shared/loading-component/loading.service";
import {LastActivePageService} from "../shared/services/last-active-page.service";
import {AuthService} from "../core/auth/auth.service";

@Injectable()
export class GenericInterceptorService implements HttpInterceptor {


  constructor(
    private router: Router,
    private injector: Injector,
    private loader: LoadingService,

  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    console.log(req);


   // this.loader.show()
    return next.handle(req).pipe(
      /*finalize(() => {
        setTimeout(() => {
          this.loader.hide()
        }, 500)
      }),*/
      tap({
        next: (data) => {
          if (data && data['body'] && data['body']['status'] === 'Token is Expired') {
            const authService = this.injector.get(AuthService);
            authService.logout();
          }
        },
        error: (err) => {
          const toastr = this.injector.get(ToastrService);
          if (err.status === 404) {
            localStorage.clear()
            this.router.navigate(['/pages/notfound'])
          }
          if (err.status === 500) {
            toastr.error('Une erreure s\'est produite sur le serveur veuillez éssayer ultérieurement', 'Erreur');
          }
          if (err.status === 422) {
            toastr.error( err.error.message,'Erreur');
            setTimeout(() => {
              if(err.error.message.includes('email')) {
                toastr.info('veuillez vous connecter','Info');
              }
            },2000)
          }
        },
      }),
    )
  }
}
